import moment from 'moment-timezone';
import { isIcebergVersion } from 'src/components/star-grid/utils/versionAvailability';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import { PnlDataVersion, SnapshotDateRange } from 'src/components/star-grid/reportSelectors.types';
import { VERSION_DATE_PRESETS } from 'src/components/star-grid/versionDateFilterConstants';

export const versionCountText = (pattern: string, count: number, total = 0): string =>
  pattern.replace('{count}', count.toLocaleString()).replace('{total}', total.toLocaleString());

export const versionRangeTitle = (range: SnapshotDateRange, text: StarGridText): string =>
  text(VERSION_DATE_PRESETS.find((preset) => preset.id === range.preset)?.labelKey ?? 'versionCustomRange');

export const versionRowPresentation = (version: PnlDataVersion) => {
  const date = moment.utc(version.as_of, moment.ISO_8601, true);
  const snapshot = isIcebergVersion(version) && date.isValid();
  return {
    displayLabel: snapshot ? date.format('YYYY-MM-DD HH:mm:ss [UTC]') : version.label,
    description: undefined,
    dateTime: date.isValid() ? date.toISOString() : undefined
  };
};
